<main class="s-siteContainer">

  <nav class="c-path" aria-label="breadcrumb" *ngIf="course">
    <div class="l-container">
      <ul class="c-path__list">
        <li><a [routerLink]="['/']" translate>Naslovnica</a></li>
        <li><a [routerLink]="['/courses']" translate>Tečajevi</a></li>
        <li *ngIf="course.educationCenter"><a [routerLink]="['/courses/centers', course.educationCenter.short_name]">
          {{course.educationCenter.name}}</a></li>
        <li class="is-active" aria-current="page"><a>{{course.title}}</a></li>
      </ul>
    </div>
  </nav>

  <div class="c-media__placeholder is-3:1 is-loading" *ngIf="!course"></div>

  <section class="c-hero" *ngIf="course">
    <div class="l-container">

      <div class="l-grid">

        <div class="l-col lg:6 sm:12">
          <div class="c-hero__body">
            <div class="c-hero__tags">
              <div class="e-tag e-tag--{{courseUtil.tagType(type.name)}} hero-tag" *ngFor="let type of course.types">
                {{type.name}}
              </div>
            </div>
            <h1 class="c-hero__title">{{course.title}}</h1>
            <figure class="c-hero__logo" *ngIf="course.organizerImage && !course.enrolment">
              <img [src]="course.organizerImage | file:'image':'lms':640" [alt]="course.organizers">
            </figure>
            <p class="c-hero__desc" *ngIf="!user && user !== undefined" translate>
              Za upis tečaja morate biti registrirani/prijavljeni.
            </p>
            <div class="c-hero__cta" *ngIf="!user && user !== undefined">
              <a [routerLink]="['/login']" class="c-btn is-primary is-outlined" translate>Prijavite se</a>
              <a [routerLink]="['/registration']" class="c-btn is-primary" translate>Registrirajte se</a>
            </div>
            <div class="c-hero__cta" *ngIf="user && !course.enrolment">
              <a class="c-btn is-secondary pointer" (click)="enrollCourse()"
                 [class.is-loading]="enrolling" translate>Upišite tečaj</a>
            </div>
            <div class="c-hero__cta" *ngIf="user && course.enrolment">
              <div class="l-grid">
                <div class="l-col">
                  <div class="c-progress" [class.is-completed]="course.enrolment?.status === 'COMPLETED'">
                    <div class="c-progress__circle js-progress" [attr.data-percent]="course.progress"></div>
                    <div class="c-progress__content">
                      <div class="c-progress__icon icon-trophy" aria-hidden="true"></div>
                      <div class="c-progress__percent">
                        {{course.progress}}%
                      </div>
                    </div>
                  </div>
                </div>
                <div class="l-col c-hero__cta_content">
                  <p translate>
                    Krenite s tečajem u vrijeme koje Vam odgovara! Možete i pregledati predavanje u više navrata.
                  </p>
                  <a [routerLink]="[courseRoute()]" class="c-btn is-secondary" translate>Otvorite tečaj</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div app-hero-image class="l-col lg:6 sm:12"
             [overrideImage]="course.mainImage ? (course.mainImage | file:'image':'lms':1280) : null"
             [alt]="course.title"></div>
      </div>

    </div>
  </section>

  <!-- Course summary section -->
  <div class="s-section has-bg-2 is-narrow" *ngIf="course">
    <div class="l-container">

      <div class="l-grid">

        <div class="l-col lg:3 md:6 sm:12">
          <div class="c-courseSummary">
            <div class="c-courseSummary__icon" aria-hidden="true">
              <i class="icon-trophy"></i>
            </div>
            <h2 class="c-courseSummary__title" translate>
              BODOVI:
            </h2>
            <p class="c-courseSummary__desc" *ngIf="course.points === null && !courseUtil.isExpired(course)" translate>
              Nema bodovanja.
            </p>
            <p class="c-courseSummary__desc" *ngIf="!courseUtil.isExpired(course) && courseUtil.points(course)">
              {{'Sudionicima se dodjeljuje' | translate}} {{courseUtil.points(course)}}.
            </p>
            <p class="c-courseSummary__desc" *ngIf="courseUtil.isExpired(course)" translate>
              Rok za polaganje je istekao, tečaj se više ne boduje.
            </p>
          </div>
        </div>

        <div class="l-col lg:3 md:6 sm:12">
          <div class="c-courseSummary">
            <div class="c-courseSummary__icon" aria-hidden="true">
              <i class="icon-clock"></i>
            </div>
            <h2 class="c-courseSummary__title" translate>
              TRAJANJE:
            </h2>
            <p class="c-courseSummary__desc">
              <span *ngIf="lecturesDuration() > 0">{{courseUtil.displayDuration(lecturesDuration())}} {{'predavanja' | translate}}.</span><br>
              <span *ngIf="testDuration() > 0">{{'Za ispunjavanje testa' | translate}} {{courseUtil.displayDuration(testDuration())}}.</span>
            </p>
          </div>
        </div>

        <div class="l-col lg:3 md:6 sm:12">
          <div class="c-courseSummary">
            <div class="c-courseSummary__icon" aria-hidden="true">
              <i class="icon-calendar"></i>
            </div>
            <h2 class="c-courseSummary__title" translate>
              DOSTUPAN:
            </h2>
            <p class="c-courseSummary__desc">
              {{courseUtil.interval(course)}}
            </p>
          </div>
        </div>

        <div class="l-col lg:3 md:6 sm:12">
          <div class="c-courseSummary">
            <div class="c-courseSummary__icon" aria-hidden="true">
              <i class="icon-check"></i>
            </div>
            <h2 class="c-courseSummary__title" translate>
              UVJET:
            </h2>
            <p class="c-courseSummary__desc" *ngIf="course.passRequirements && course.passRequirements > 0">
              {{'Pregledano' | translate}} <strong>{{'minimalno' | translate}} {{course.passRequirements}}% {{'predavanja' | translate}}.</strong>
            </p>
            <p class="c-courseSummary__desc" *ngIf="!course.passRequirements || course.passRequirements <= 0" translate>
              Nema uvjeta za polaganje tečaja
            </p>
          </div>
        </div>

      </div>

    </div>
  </div>

  <section class="s-section" *ngIf="course">
    <div class="l-container--md">

      <div class="s-section__main">
        <div class="c-tab">

          <ul class="c-tab__list js-tabs" role="tablist">
            <li class="c-tab__list_tab" role="tab" aria-controls="tp-1" id="t1" translate>
              O tečaju
            </li>
            <li class="c-tab__list_tab" role="tab" aria-controls="tp-2" id="t2" translate>
              Lekcije
            </li>
            <li class="c-tab__list_tab" role="tab" aria-controls="tp-3" id="t3" translate>
              Korisne informacije
            </li>
            <li class="c-tab__list_tab" role="tab" aria-controls="tp-4" id="t4" translate>
              Predavači
            </li>
          </ul>

          <div class="c-tab__panels">

            <!-- Tab: O tečaju -->
            <div class="c-tab__panel" role="tabpanel" id="tp-1" aria-labelledby="t1" tabindex="0">

              <div class="c-courseIntro">

                <div class="c-courseIntro__content c-editor">
                  {{course.description}}
                </div>

                <div class="c-courseIntro__sponsors" *ngIf="course.sponsors && course.sponsors.length > 0">
                  <span translate>Sponzori:</span>
                  <div class="c-sponsor" *ngFor="let sponsor of course.sponsors">
                    <div class="c-sponsor__img">
                      <a [href]="sponsor.websiteLink" target="_blank">
                        <img [src]="sponsor.mainImage | file:'image':'lms':640" [alt]="sponsor.name">
                      </a>
                    </div>
                    <div class="c-sponsor__content">
                      <h3 class="c-sponsor__content_title">
                        <a [href]="sponsor.websiteLink" target="_blank">{{sponsor.name}}</a>
                      </h3>
                      <p class="c-sponsor__content_desc">{{sponsor.description}}</p>
                    </div>
                  </div>
                </div>

              </div>

            </div>
            <!-- /Tab: O tečaju -->

            <!-- Tab: Lekcije -->
            <div app-course-navigation class="c-tab__panel" role="tabpanel" id="tp-2" aria-labelledby="t2" tabindex="0"
            [course]="course" (activeElementIdChange)="lessonElementClick($event)">
            </div>
            <!-- /Tab: Lekcije -->

            <!-- Tab: Korisne informacije -->
            <div class="c-tab__panel" role="tabpanel" id="tp-3" aria-labelledby="t3" tabindex="0">

              <div class="c-files">

                <div class="c-courseIntro__content c-editor" *ngIf="downloadableFiles.length === 0" translate>
                  Tečaj ne sadrži dodatne datoteke za preuzimanje
                </div>

                <ol class="c-files__list">

                  <li class="c-files__item" *ngFor="let file of downloadableFiles">
                    <h3 class="c-files__item_title">
                      {{file.content['title']}}
                    </h3>
                    <figure class="c-files__item_img">
                      <img *ngIf="isWord(file.content['fileData'])" src="./assets/images/ui/icon-word.svg" alt="Word">
                      <img *ngIf="isPdf(file.content['fileData'])" src="./assets/images/ui/icon-pdf.svg" alt="PDF">
                    </figure>
                    <div class="c-files__item_link">
                      <a [attr.href]="user ? (file.content['fileData'] | file:'other':'lms') : null"
                         target="_blank" class="c-btn is-secondary" [attr.disabled]="user ? null : true"
                         [class.is-disabled]="!user" translate>Preuzmi</a>
                      <p *ngIf="!user" translate>
                        Za preuzimanje dokumenata morate biti registrirani/prijavljeni.
                      </p>
                    </div>
                  </li>

                </ol>

              </div>

            </div>
            <!-- /Tab: Korisne informacije -->

            <!-- Tab: Predavači -->
            <div class="c-tab__panel" role="tabpanel" id="tp-4" aria-labelledby="t4" tabindex="0">

              <div class="c-courseIntro__content c-editor" *ngIf="course.lecturers?.length === 0" translate>
                Predavači za tečaj nisu navedeni
              </div>

              <div class="c-lecturer" *ngFor="let lecturer of course.lecturers">
                <figure class="c-lecturer__img is-1:1">
                  <img [src]="lecturer.mainImage | file:'image':'lms':640"
                       [alt]="lecturerName(lecturer)">
                </figure>
                <div class="c-lecturer__content">
                  <h3 class="c-lecturer__content_title">
                    {{lecturerName(lecturer)}}
                  </h3>
                  <p class="c-lecturer__content_desc" *ngIf="lecturer.description">
                    {{lecturer.description}}
                  </p>
                </div>
              </div>

            </div>
            <!-- /Tab: Predavači -->

          </div>

        </div>
      </div>

    </div>
  </section>

  <section class="s-section has-bg-2" *ngIf="course">
    <div class="l-container">

      <div class="s-section__header" *ngIf="!loadingCourses && recommendedCourses.length > 0">
        <h2 class="s-section__title" translate>
          Naši korisnici pregledali su i ove tečajeve
        </h2>
      </div>

      <div app-slider class="s-section__main" [loading]="loadingCourses"
           [tabs]="[{items: recommendedCourses}]"></div>

    </div>
  </section>

  <section class="s-section" *ngIf="course">
    <div class="l-container--md">

      <div class="s-section__header">
        <h2 class="s-section__title is-centered is-clean" translate>
          Često postavljena pitanja
        </h2>
      </div>

      <div class="s-section__main">
        <div class="c-accordion js-accordion">
          <div class="c-accordion__item" *ngFor="let faq of faqs; let i = index">
            <button class="c-accordion__title" [attr.aria-controls]="'ap-' + i" [attr.aria-expanded]="false" [attr.id]="'at-' + i">
              {{ faq.question }}
            </button>
            <div class="c-accordion__body" [attr.id]="'ap-' + i" role="region" [attr.aria-labelledby]="'at-' + i" aria-hidden="true">
              <div class="c-editor">
                {{ faq.answer }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

</main>

<app-subscription-form *ngIf="!user"></app-subscription-form>
